/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/how-to/querying-data/use-static-query/
 */

import * as React from "react"
import { useStaticQuery, graphql } from "gatsby"

// import Header from "./header"
import 'bootstrap/dist/css/bootstrap.min.css'
import '../css/custom.css'

import { Container } from "react-bootstrap"

const Layout = ({ children }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  return (
    <>
      {/* <Header siteTitle={data.site.siteMetadata?.title || `Title`} /> */}

        <main>{children}</main>
        <footer className="p-5">
          <Container>
            {/* <div className="d-flex justify-content-center">
              <a href="https://twitter.com" className="mx-3">
                <FontAwesomeIcon icon={faTwitter} size="lg" />
              </a>
              <a href="https://instagram.com" className="mx-3">
                <FontAwesomeIcon icon={faInstagram} size="lg" />
              </a>
            </div> */}
            <div className="d-none">{data.site.siteMetadata.title}</div>
            <p className="text-center mt-3">
            © {new Date().getFullYear()}, Nicole Marzo
            </p>
            <p className="text-center mt-3">Site designed by <a href="https://nautilusdesigns.com">Nautilus Designs</a>           </p>
          </Container>
          
        </footer>
    </>
  )
}

export default Layout
